import React from 'react';
import { StoreList } from '../components/stores/StoreList';

export function Stores() {
  return (
    <div className="container mx-auto px-4 py-8 animate-fade-in">
      <StoreList />
    </div>
  );
}